/**
 * Breadcrumb structured data (the only helper still used; round 5 removed the
 * unused business, person, FAQ and service templates. The live structured data
 * is in public/index.html and src/utils/structuredData.js).
 */

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});
